import { taskIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const claimAndStartTask = {
  name: "claimAndStartTask" as const,
  input: z.object({ taskId: taskIdFormat.schema }),
  output: z.object({ redirectUrl: z.string() }),
};
